import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function MobileSearchBar() {
  const { t } = useLang();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const timerRef = useRef(null);

  const handleSearch = (val) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (val.trim()) navigate(`/fatwas?q=${encodeURIComponent(val)}`);
    }, 500);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      clearTimeout(timerRef.current);
      const val = e.target.value;
      if (val.trim()) navigate(`/fatwas?q=${encodeURIComponent(val)}`);
    }
  };

  return (
    <div className="mob-search-bar">
      <div className="mob-search-bar-inner">
        <input
          type="text"
          ref={searchRef}
          placeholder={t('header.search.placeholder')}
          onChange={e => handleSearch(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button onClick={() => handleSearch(searchRef.current?.value || '')}>🔍</button>
      </div>
    </div>
  );
}
